import { ReviewedStatus } from '@weave/schema-gen-ts/dist/schemas/schedule/v3/booking_submission.pb';
import { ScheduleQueries, ScheduleTypes } from '@frontend/api-schedule';
import { SchedulerV3 } from '@frontend/api-schedule-v3';

export const useApproveScheduleRequestQuery = () => {
  const { isScheduleV3FlagEnabled } = SchedulerV3.Helpers.useGetSchedulerV3FeatureFlagDetails();

  const updateScheduleRequestMutation = ScheduleQueries.useUpdateScheduleRequest();

  const updateScheduleRequestMutationV3 = SchedulerV3.Mutations.useUpdateBookingSubmissionMutation();

  /*
    In combined v2 and v3 requests list, if the selected request is a v2 request, we should call v2 endpoint for approval.
    Approval API saves the v2 request in data service which is used to display the request history on UI.
   */
  const approveScheduleRequest = (request: ScheduleTypes.UpdateScheduleRequestType['input'], requestVersion = '') => {
    if (isScheduleV3FlagEnabled && requestVersion !== 'v2') {
      return updateScheduleRequestMutationV3.mutateAsync({
        submissionId: request.id ?? '',
        reviewedBy: request.reviewedBy ?? '',
        reviewedStatus: ReviewedStatus.ACCEPTED,
        appointmentDateTime: request.dateTime ?? '',
      });
    }
    return updateScheduleRequestMutation.mutateAsync(request);
  };

  return {
    approveScheduleRequest,
    isLoading: updateScheduleRequestMutation.isLoading || updateScheduleRequestMutationV3.isLoading,
    isError: updateScheduleRequestMutation.isError || updateScheduleRequestMutationV3.isError,
  };
};
